<template>
    <v-container>
        <m-form ref="form" autocomplete="disabled">
            <v-row>
                <v-col>
                    <m-text-field label="CNPJ: "
                                  id="FieldCnpj"
                                  class="required"
                                  v-mask="cnpjMask"
                                  :rules="[$rules.required, $rules.cnpj]"
                                  v-model="pedido.cliente.cnpj"
                                  outlined
                                  @keyup="handleKeyDownDocumento"
                                  @blur="getCliente"
                                  :name="generateDynamicName('cnpj')"
                                  autocomplete="disabled">
                    </m-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <m-text-field label="Razão social: "
                                  id="FieldRazaoSocial"
                                  class="required"
                                  v-model="pedido.cliente.razao_social"
                                  v-input-filter="model_search.razao_social || [$filters.textnumeric]"
                                  :rules="[$rules.required, validacaoRazaoSocialClienteNewCon, validacaoRazaoSocialClienteBase]"
                                  outlined
                                  @change="validacaoMensagem = true"
                                  v-uppercase
                                  maxlength="200"
                                  :disabled="model_search.razao_social"
                                  :name="generateDynamicName('razao_social')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col>
                    <m-text-field label="Nome fantasia: "
                                  id="FieldNomeFantasia"
                                  class="required"
                                  v-model="pedido.cliente.nome_fantasia"
                                  v-input-filter="model_search.nome_fantasia || [$filters.textnumeric]"
                                  outlined
                                  :rules="[$rules.required]"
                                  v-uppercase
                                  maxlength="150"
                                  :disabled="model_search.nome_fantasia"
                                  :name="generateDynamicName('nome_fantasia')"
                                  autocomplete="disabled" />
                </v-col>
            </v-row>
            <v-row>
                <v-col md>
                    <DateField label="Data de fundação: "
                               id="FieldDataFundacao"
                               class="required"
                               :rules="[$rules.required, $rules.dataMaxima500, $rules.dataPassada]"
                               v-model="pedido.cliente.data_fundacao"
                               :disabled="model_search.data_fundacao"
                               autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md="5">
                    <v-select label="Tipo de empresa: "
                              id="SelectTipoEmpresa"
                              :placeholder="pedido.cliente.id_tipo_empresa ? '' : 'Selecione o tipo de empresa'"
                              :items="tipos_empresa"
                              item-text="nome"
                              item-value="id_tipo_empresa"
                              class="required"
                              :rules="[$rules.required]"
                              v-model="pedido.cliente.id_tipo_empresa"
                              :disabled="model_search.id_tipo_empresa"
                              clearable
                              outlined
                              autocomplete="disabled" />
                </v-col>
                <v-col md>
                    <m-text-field label="Número de registro dos dados constitutivos: "
                                  id="FieldDadosConst"
                                  maxlength="100"
                                  v-model="pedido.cliente.registro_dados_constitutivos"
                                  v-input-filter="[$filters.alphanumeric]"
                                  outlined
                                  :name="generateDynamicName('registros')"
                                  autocomplete="disabled" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <v-select label="Atividade: "
                              id="SelectAtividade"
                              :placeholder="pedido.cliente.id_atividade ? '' : 'Selecione a atividade'"
                              class="required"
                              :items="atividades"
                              item-text="nome"
                              item-value="id_atividade"
                              v-model="pedido.cliente.id_atividade"
                              :disabled="model_search.id_atividade"
                              :rules="[$rules.required]"
                              clearable
                              outlined
                              autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md>
                    <m-text-field label="Inscrição estadual:"
                                  id="FieldInscricaoEstadual"
                                  v-model="pedido.cliente.inscricao_estadual"
                                  v-input-filter="pedido.cliente.isento_inscricao ? [] : [$filters.numeric]"
                                  :disabled="pedido.cliente.isento_inscricao"
                                  maxlength="50"
                                  :rules="[$rules.required]"
                                  class="required"
                                  outlined
                                  :name="generateDynamicName('incricao_estadual')"
                                  autocomplete="disabled" />
                    <v-row>
                        <v-checkbox class="pt-0" v-model="pedido.cliente.isento_inscricao" @change="toggleIsentoInscricao" />
                        <label>Isento</label>
                    </v-row>
                </v-col>
                <v-col cols="12" md>
                    <MoneyTextField label="Faturamento:"
                                    id="FieldFaturamento"
                                    class="required"
                                    outlined
                                    maxvalue="999999999999"
                                    :rules="[$rules.required]"
                                    v-model="pedido.cliente.faturamento_medio" />
                </v-col>
                <v-col cols="12" md>
                    <MoneyTextField label="Patrimônio:"
                                    id="FieldPatrimonio"
                                    outlined
                                    maxvalue="999999999.99"
                                    v-model="pedido.cliente.patrimonio"
                                    :disabled="model_search.patrimonio" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md>
                    <m-text-field label="Celular:"
                                  id="FieldCelular"
                                  class="required"
                                  v-model="pedido.cliente.telefone_celular"
                                  v-mask="'(##) #####-####'"
                                  :rules="[$rules.required, $rules.celular]"
                                  outlined
                                  :name="generateDynamicName('celular')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md>
                    <m-text-field label="Telefone fixo:"
                                  id="FieldTelefone"
                                  v-model="pedido.cliente.telefone_comercial"
                                  v-mask="'(##) ####-####'"
                                  :rules="[$rules.telefone]"
                                  outlined
                                  :name="generateDynamicName('telefone')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md="6">
                    <InputEmail label="E-mail:"
                                id="FieldEmail"
                                class="required"
                                ref="emailField"
                                outlined
                                v-input-filter="[$filters.email]"
                                v-model="pedido.cliente.email"
                                @input="onEmailInput"
                                :rules="[$rules.required, validarEmail]" />
                </v-col>
            </v-row>
            <v-col class="titulo text-center">Dados do sócio</v-col>
            <v-row>
                <v-col cols="12" md="3">
                    <m-text-field label="CPF:"
                                  id="FieldSocioCpf"
                                  class="required"
                                  v-mask="'###.###.###-##'"
                                  ref="cpf_socio"
                                  outlined
                                  :rules="[$rules.required, $rules.cpf]"
                                  v-model="pedido.cliente.cpf_socio"
                                  @input="handleInputSocioCpf"
                                  @change="validacaoMensagem = true"
                                  @blur="getSocio"
                                  :name="generateDynamicName('cpf_socio')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md="6">
                    <m-text-field ref="nome_completo"
                                  label="Nome completo:"
                                  id="FieldSocioNomeCompleto"
                                  class="required"
                                  maxlength="150"
                                  v-uppercase
                                  outlined
                                  v-input-filter="socio_search.nome_completo || [$filters.text]"
                                  :rules="[$rules.required]"
                                  v-model="pedido.cliente.nome_completo"
                                  :disabled="socio_search.nome_completo"
                                  :name="generateDynamicName('nome_completo')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md="3">
                    <DateField ref="data_nascimento_socio"
                               label="Data de nascimento:"
                               id="FieldSocioDataNascimento"
                               v-model="pedido.cliente.data_nascimento_socio"
                               :rules="[$rules.required, dataMinima, $rules.dataMaxima150]"
                               :disabled="socio_search.data_nascimento_socio" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-radio-group ref="genero"
                                   label="Sexo de nascimento:"
                                   id="GroupSocioGenero"
                                   class="required"
                                   v-model="pedido.cliente.genero"
                                   :disabled="socio_search.genero"
                                   :rules="[$rules.required]">
                        <v-row>
                            <v-col cols="6">
                                <v-radio label="Feminino"
                                         id="RadioSocioFeminino"
                                         value="feminino" />
                            </v-col>
                            <v-col cols="6">
                                <v-radio label="Masculino"
                                         id="RadioSocioMasculino"
                                         value="masculino" />
                            </v-col>
                        </v-row>
                    </v-radio-group>
                </v-col>
                <v-col cols="12" md>
                    <v-select ref="nacionalidade"
                              label="Nacionalidade:"
                              id="FieldSocioNacionalidade"
                              class="required"
                              :placeholder="pedido.cliente.nacionalidade ? '' : 'Selecione a nacionalidade'"
                              :items="nacionalidades"
                              v-model="pedido.cliente.nacionalidade"
                              :clearable="!model_search.nacionalidade"
                              :disabled="socio_search.nacionalidade"
                              :rules="[$rules.required]"
                              outlined
                              autocomplete="disabled" />
                </v-col>
                <v-col cols="12" md="4">
                    <MoneyTextField ref="percentual_participacao"
                                    label="Percentual de participação:"
                                    id="FieldPercentualParticipacao"
                                    class="required"
                                    outlined
                                    maxlength="18"
                                    v-model="pedido.cliente.percentual_participacao"
                                    :rules="[$rules.required]"
                                    :options="{ locale: 'pt-BR', suffix: '%', precision: 2, prefix: '' }"
                                    maxvalue="100" />
                </v-col>
            </v-row>
            <PoliticamenteExposto ref="politicamente_exposto" v-model="pedido.cliente" />
            <v-col cols="12" md="3">
                <v-radio-group ref="beneficiario"
                               id="GroupSocioBeneficiario"
                               label="O sócio é o beneficiário final da empresa?"
                               class="required"
                               v-model="pedido.cliente.exibir_campos_beneficiario"
                               @change="limparDadosBeneficiario(true)"
                >
                    <v-row>
                        <v-col cols="6">
                            <v-radio label="Sim"
                                     id="RadioSocioBeneficiarioFinal"
                                     :value="false" />
                        </v-col>
                        <v-col cols="6">
                            <v-radio label="Não"
                                     id="RadioSocioNaoBeneficiarioFinal"
                                     :value="true"
                            />
                        </v-col>
                    </v-row>
                </v-radio-group>
            </v-col>
            <div v-if="pedido.cliente.exibir_campos_beneficiario">
                <v-col class="titulo text-center">DADOS DO BENEFICIÁRIO FINAL</v-col>
                <v-row>
                    <v-col cols="12" md="3">
                        <m-text-field label="CPF:"
                                      id="FieldSocioBeneficiarioCpf"
                                      class="required"
                                      v-mask="'###.###.###-##'"
                                      ref="cpf_beneficiario"
                                      outlined
                                      :rules="[$rules.required, $rules.cpf]"
                                      v-model="pedido.cliente.beneficiario.cpf"
                                      @input="handleInputBeneficiarioCpf"
                                      @keyup="handleKeyDownDocumentoBeneficiario"
                                      @blur="getBeneficiario"
                                      :name="generateDynamicName('cpf_beneficiario')"
                                      autocomplete="disabled" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <m-text-field ref="nome_completo_beneficiario"
                                      id="FieldSocioBeneficiarioNomeCompleto"
                                      label="Nome completo:"
                                      class="required"
                                      maxlength="150"
                                      v-uppercase
                                      outlined
                                      @change="validacaoMensagem = true"
                                      v-input-filter="beneficiario_search.nome_completo || [$filters.text]"
                                      :rules="[$rules.required]"
                                      v-model="pedido.cliente.beneficiario.nome_completo"
                                      :disabled="beneficiario_search.nome_completo"
                                      :name="generateDynamicName('nome_beneficiario')"
                                      autocomplete="disabled" />
                    </v-col>
                    <v-col cols="12" md="3">
                        <DateField ref="data_nascimento_beneficiario"
                                   id="FieldSocioBeneficiarioDataNascimento"
                                   label="Data de nascimento:"
                                   v-model="pedido.cliente.beneficiario.data_nascimento"
                                   :rules="[$rules.required, dataMinima, $rules.dataMaxima150]"
                                   :disabled="beneficiario_search.data_nascimento" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="3">
                        <v-radio-group ref="genero_beneficiario"
                                       id="GroupSocioBeneficiarioGenero"
                                       label="Sexo de nascimento:"
                                       class="required"
                                       v-model="pedido.cliente.beneficiario.genero"
                                       :disabled="beneficiario_search.genero"
                                       :rules="[$rules.required]">
                            <v-row>
                                <v-col cols="6">
                                    <v-radio label="Feminino"
                                             id="RadioSocioBeneficiarioFeminino"
                                             value="feminino" />
                                </v-col>
                                <v-col cols="6">
                                    <v-radio label="Masculino"
                                             id="RadioSocioBeneficiarioMasculino"
                                             value="masculino" />
                                </v-col>
                            </v-row>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" md>
                        <v-select ref="nacionalidade_beneficiario"
                                  id="FieldSocioBeneficiarioNacionalidade"
                                  label="Nacionalidade:"
                                  placeholder="Selecione a nacionalidade"
                                  class="required"
                                  :items="nacionalidades"
                                  v-model="pedido.cliente.beneficiario.nacionalidade"
                                  :clearable="!model_search.nacionalidade_beneficiario"
                                  :disabled="beneficiario_search.nacionalidade"
                                  :rules="[$rules.required]"
                                  outlined
                                  autocomplete="disabled" />
                    </v-col>
                </v-row>
                <PoliticamenteExposto ref="politicamente_exposto_beneficiario" v-model="pedido.cliente.beneficiario" />
            </div>
        </m-form>
        <v-row class="justify-space-between mt-8">
            <v-btn v-if="fluxoProduto" id="ButtonVoltar" color="secondary" text @click="prev()">
                Voltar
            </v-btn>
            <v-col class="text-center red--text mb-4">
                Campos obrigatórios *
            </v-col>
            <template v-if="bloqueado_newcon == 1">
                <v-tooltip left
                           max-width="300px"
                           color="lightgray"
                           nudge-top="50"
                           nudge-right="8"
                >
                    <template #activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" style="display: flex;">
                            <v-btn id="ButtonContinuar" color="primary" @click="openDialog" :disabled="bloqueado_newcon == 1 || isButtonDisabled">
                                Continuar
                            </v-btn>
                        </div>
                    </template>
                    <div class="d-flex align-center">
                        <span style="color: var(--primary)" class="font-weight-bold text-left">Cliente bloqueado para realizações de compras na Administradora.</span>
                    </div>
                </v-tooltip>
            </template>
            <template v-else>
                <v-btn id="ButtonContinuar" color="primary" @click="openDialog" :disabled="isButtonDisabled">
                    Continuar
                </v-btn>
            </template>
        </v-row>
        <DialogConfirmarAlterarEmail
                v-model="dialogEmailOpen"
                :email="pedido.cliente.email"
                @confirmar="handleEmailConfirmed"
                @alterar="focus"
        />
    </v-container>
</template>

<script>
  import { get, isEmpty, isNil, isString, merge, omit } from 'lodash'
  import moment from 'moment'
  import { notification } from '@/plugins/helpers'
  import { validaCNPJ, validaCPF, minimumAge } from '@/plugins/validation'
  import { TipoPessoa, Nacionalidades, TipoTelefone } from '@/plugins/constants'
  import { toDateBR } from '@/plugins/formatters'
  import PoliticamenteExposto from '@/views/cadastro/cliente/PoliticamenteExposto'
  import masker from 'vue-the-mask/src/masker'
  import { tokens } from 'vue-the-mask'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import { mapState } from 'vuex'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import faturamentoMinimo from '@/mixins/faturamentoMinimo'
  import InputEmail from '../../../components/inputs/InputEmail.vue'
  import DialogConfirmarAlterarEmail from '../../../dialogs/DialogConfirmarAlterarEmail.vue'
  import emailMixin from '../../../mixins/emailMixin'
  import dynamicNameMixin from '../../../mixins/dynamicNameMixin'

  const clienteDefault = () => ({
    bloqueado: false,
    socio_bloqueado: false,
    pessoa: TipoPessoa.Juridica,
    cnpj: '',
    razao_social: '',
    nome_fantasia: '',
    data_fundacao: '',
    id_atividade: null,
    id_tipo_empresa: null,
    inscricao_estadual: '',
    isento_inscricao: false,
    registro_dados_constitutivos: '',
    patrimonio: 0,
    faturamento_medio: 0,
    cpf_socio: '',
    nome_completo: '',
    data_nascimento_socio: '',
    genero: null,
    nacionalidade: '',
    email: '',
    telefone_comercial: '',
    telefone_celular: '',
    percentual_participacao: 0,
    politicamente_exposto: null,
    id_parentesco: null,
    id_cargo_politico: null,
    tribanco: false,
    enderecos: [],
    exibir_campos_beneficiario: false,
    beneficiario: {
      cpf: '',
      nome_completo: '',
      data_nascimento: '',
      genero: null,
      nacionalidade: '',
      email: '',
      telefone_comercial: '',
      telefone_celular: '',
      percentual_participacao: 0,
      politicamente_exposto: null,
      id_parentesco: null,
      id_cargo_politico: null,
      bloqueado: false
    }
  })
  const baseIntermediariaMap = {
    registro_dados_constitutivos: {
      key: 'registro_dados_constitutivos',
      value: val => val
    }
  }
  const newConClienteMap = {
    NM_Razao_Social: {
      key: 'razao_social',
      value: val => val
    },
    NM_Fantasia: {
      key: 'nome_fantasia',
      value: val => val
    },
    DT_Fundacao: {
      key: 'data_fundacao',
      value: val => val
    },
    VL_Faturamento_Medio: {
      key: 'faturamento_medio',
      value: val => val
    },
    ID_Atividade: {
      key: 'id_atividade',
      value: val => val
    },
    PE_Participacao_Socio: {
      key: 'percentual_participacao',
      value: val => val
    },
    NO_Documento: {
      key: 'inscricao_estadual',
      value: val => val
    },
    VL_Patrimonio_Total: {
      key: 'patrimonio',
      value: val => val
    }
  }
  const newConSocioMap = {
    CD_Inscricao_Nacional: {
      key: 'cpf_socio',
      value: val => val
    },
    NM_Pessoa: {
      key: 'nome_completo',
      value: val => val
    },
    DT_Nascimento: {
      key: 'data_nascimento_socio',
      value: val => val
    },
    ST_Sexo: {
      key: 'genero',
      value: val => !isNil(val) ? (val === 'F' ? 'feminino' : 'masculino') : null
    },
    NM_Nacionalidade: {
      key: 'nacionalidade',
      value: val => val.trim()
    }
  }

  const newConBeneficiarioMap = {
    CD_Inscricao_Nacional: {
      key: 'beneficiario.cpf',
      value: val => val
    },
    NM_Pessoa: {
      key: 'beneficiario.nome_completo',
      value: val => val
    },
    DT_Nascimento: {
      key: 'beneficiario.data_nascimento',
      value: val => val
    },
    ST_Sexo: {
      key: 'beneficiario.genero',
      value: val => !isNil(val) ? (val === 'F' ? 'feminino' : 'masculino') : null
    },
    NM_Nacionalidade: {
      key: 'beneficiario.nacionalidade',
      value: val => val
    }
  }
  export default {
    name: 'Juridica',
    components: { PoliticamenteExposto, DialogConfirmarAlterarEmail, InputEmail },
    mixins: [faturamentoMinimo, emailMixin, dynamicNameMixin],
    props: { value: Object },
    data: () => ({
      dialogEmailOpen: false,
      finalizouFluxoTela: false,
      ultimoDocumentoInserido: null,
      ultimoCpfBeneficiarioInserido: '',
      permite_cnpj_alfanumerico: false,
      is_tribanco: false,
      percentual_minimo_faturamento: 0,
      atividades: [],
      nacionalidades: [ Nacionalidades.Brasileira, Nacionalidades.Estrangeira ],
      validacaoMensagem: true,
      pedido: {
        cliente: clienteDefault()
      },
      model_search: {
        razao_social: false,
        nome_fantasia: false,
        data_fundacao: false,
        id_atividade: false,
        faturamento_medio: false
      },
      socio_search: {
        cpf_socio: false,
        percentual_participacao: false,
        genero: false,
        nacionalidade: false,
        data_nascimento_socio: false,
        nome_completo: false,
        exibir_campos_beneficiario: false
      },
      beneficiario_search: {
        cpf: false,
        percentual_participacao: false,
        genero: false,
        nacionalidade: false,
        data_nascimento: false,
        nome_completo: false
      },
      tipos_empresa: [],
      confirma_Beneficiario: [],
      configuracao_idade: 16,
      pessoaJuridicaIntermediariaResponse: [],
      bloqueado_newcon: 0
    }),
    computed: {
      cnpjMask () {
        if (this.permite_cnpj_alfanumerico) {
          return {
            mask: 'SS.SSS.SSS/SSSS-SS',
            tokens: {
              'S': {
                pattern: /[A-Za-z0-9]/,
                transform: (char) => char.toUpperCase()
              }
            }
          }
        }
        return '##.###.###/####-##'
      },
      fluxoProduto () {
        return this.$route.name === 'iniciar-venda'
      },
      Nacionalidades: () => Nacionalidades,
      ...mapState([ 'id_usuario', 'jornada_venda' ]),
      validacaoRazaoSocialClienteNewCon () {
        return this.validacaoMensagem
      },
      validacaoRazaoSocialClienteBase () {
        const cliente = this.pedido?.cliente
        const beneficiario = cliente?.beneficiario

        let razaoSocial = cliente?.razao_social?.trim() ?? ''
        let nomeCompleto = cliente?.nome_completo?.trim() ?? ''
        const nomeCompletoBeneficiario = beneficiario?.nome_completo?.trim() ?? ''

        if (cliente?.bloqueado) {
          return true
        }

        return (razaoSocial && (razaoSocial === nomeCompleto || razaoSocial === nomeCompletoBeneficiario))
          ? 'Os campos "Razão Social" e "Nome Completo" do Sócio ou do beneficiário final estão iguais'
          : true
      },
      isButtonDisabled () {
        return !(this.validacaoRazaoSocialClienteNewCon === true && this.validacaoRazaoSocialClienteBase === true)
      }
    },
    watch: {
      value () {
        this.update()
      },
      'value.cliente' (cliente) {
        if (this.finalizouFluxoTela) {
          return
        }
        const beneficiario = { ...this.pedido.cliente.beneficiario, ...cliente.beneficiario }
        Object.assign(this.pedido.cliente, cliente)
        this.pedido.cliente.beneficiario = beneficiario
        if (this.pedido.cliente.bloqueado) {
          Object.keys(this.model_search).forEach(key => {
            this.model_search[key] = !!this.pedido.cliente[key]
          })
          if (this.pedido.cliente.socio_bloqueado) {
            Object.keys(this.socio_search).forEach(key => {
              this.socio_search[key] = !!this.pedido.cliente[key]
            })
          }
          if (this.pedido.cliente.beneficiario.bloqueado) {
            Object.keys(this.beneficiario_search).forEach(key => {
              this.beneficiario_search[key] = !!this.pedido.cliente.beneficiario[key]
            })
          }
        }
        if (this.pedido.cliente.beneficiario.cpf && this.pedido.cliente.beneficiario.cpf !== this.pedido.cliente.cpf_socio) {
          this.pedido.cliente.exibir_campos_beneficiario = true
        } else {
          this.limparDadosBeneficiario()
          this.pedido.cliente.exibir_campos_beneficiario = false
        }
      },
      'pedido.cliente.id_tipo_empresa' (val) {
        // Em uma edição, se o usuário desmarcar o valor deve enviar null pro servidor. Parâmetros undefined não são enviados
        this.pedido.cliente.id_tipo_empresa = val === undefined ? null : val
      },
      'pedido.cliente.inscricao_estadual' (val) {
        if (val === 'ISENTO') {
          this.pedido.cliente.isento_inscricao = true
        } else {
          this.pedido.cliente.isento_inscricao = false
        }
        this.desbloquearInscricaoEstadual()
      }
    },
    created () {
      this.update()
      Promise.all([this.getAtividades(), this.getTiposEmpresa(), this.loadConfiguracaoIdade()])
      this.is_tribanco = this.$session.get('flavor') === 'tribanco'
      this.id_usuario_interno = this.$session.get('id_usuario_interno')

      if (this.pedido.cliente.beneficiario.length > 0) {
        this.pedido.cliente.exibir_campos_beneficiario = true
      }
      this.permite_cnpj_alfanumerico = this.$session.get('permite_cnpj_alfanumerico')
    },
    methods: {
      desbloquearInscricaoEstadual () {
        this.model_search.inscricao_estadual = false
      },
      toggleIsentoInscricao () {
        if (this.pedido.cliente.isento_inscricao) {
          this.pedido.cliente.inscricao_estadual = 'ISENTO'
        } else {
          this.pedido.cliente.inscricao_estadual = ''
        }
      },
      toDateBR (val) {
        return val.includes('-') ? toDateBR(val) : val
      },
      isReservaCompleta () {
        return this.pedido.reserva && this.pedido.reserva.completa
      },
      handleInputSocioCpf (newValue) {
        if (this.pedido.cliente.cpf_socio !== newValue) {
          this.resetSocio()
        }
      },
      handleInputBeneficiarioCpf (newValue) {
        if (this.pedido.cliente.beneficiario.cpf !== newValue) {
          this.resetBeneficiario()
        }
      },
      handleKeyDownDocumento (event) {
        if (this.ultimoDocumentoInserido !== event.target.value) {
          this.resetPessoaJuridica(true)
        }
      },
      resetUltimoDocumentoPj () {
        this.ultimoDocumentoInserido = null
      },
      handleKeyDownDocumentoBeneficiario (event) {
        if (event.target.value.length < this.ultimoCpfBeneficiarioInserido.length) {
          this.limparDadosBeneficiario(false)
        }
        this.ultimoCpfBeneficiarioInserido = event.target.value
      },
      update () {
        if (this.finalizouFluxoTela) {
          return
        }

        this.pedido = merge({}, this.pedido, this.value)

        if (this.value.cliente.cpf && !this.pedido.cliente.cpf_socio) {
          this.pedido.cliente.cpf_socio = this.value.cliente.cpf
        }
        if (this.value.cliente.data_nascimento && !this.pedido.cliente.data_nascimento_socio) {
          this.pedido.cliente.data_nascimento_socio = this.value.cliente.data_nascimento
        }

        if (this.pedido.cliente.cnpj) {
          this.ultimoDocumentoInserido = this.pedido.cliente.cnpj
        }
        if (this.pedido.cliente.faturamento_medio) {
          this.pedido.cliente.faturamento_medio = parseFloat(this.value.cliente.faturamento_medio).toFixed(2)
        }
        if (this.pedido.cliente.renda) {
          this.pedido.cliente.renda = parseFloat(this.value.cliente.renda).toFixed(2)
        }
        if (this.pedido.cliente.percentual_participacao) {
          this.pedido.cliente.percentual_participacao = parseFloat(this.value.cliente.percentual_participacao).toFixed(2)
        }
        if (!this.pedido.cliente.isento_inscricao) {
          this.desbloquearInscricaoEstadual()
        }
        if (this.pedido.cliente.bloqueado) {
          Object.keys(this.model_search).forEach(key => {
            const val = this.pedido.cliente[key]
            this.model_search[key] = !isNil(val) && (!isString(val) || !isEmpty(val))
          })
        }
        if (this.pedido.cliente.socio_bloqueado) {
          Object.keys(this.socio_search).forEach(key => {
            const val = this.pedido.cliente[key]

            this.socio_search[key] = !isNil(val) && (!isString(val) || !isEmpty(val))
          })
        }
        if (this.pedido.cliente.beneficiario.bloqueado) {
          Object.keys(this.beneficiario_search).forEach(key => {
            const val = this.pedido.cliente[key]

            this.beneficiario_search[key] = !isNil(val) && (!isString(val) || !isEmpty(val))
          })
        }
        if (!this.is_tribanco && this.pedido.cliente.socio_bloqueado) {
          this.getSocio(this.pedido.cliente.cpf_socio) // Busca o sócio novamente para ofuscar os campos
        }
        if (!this.is_tribanco && this.pedido.cliente.beneficiario.bloqueado) {
          this.getBeneficiario(this.pedido.cliente.beneficiario.cpf)
        }
      },
      async resetPessoaJuridica (resetaNaoBloqueado = false) {
        if (this.pedido.cliente.bloqueado || resetaNaoBloqueado) {
          this.pedido.cliente.bloqueado = false
          this.ultimoDocumentoInserido = null
          this.validacaoMensagem = true
          this.limparDados()
          this.desbloquearCampos()
          this.resetSocio()
          this.resetBeneficiario()
        }
      },
      resetSocio () {
        this.pedido.cliente.socio_bloqueado = false
        this.limparDadosSocio()
        this.desbloquearCamposSocio()
      },
      resetBeneficiario () {
        this.pedido.cliente.beneficiario.bloqueado = false
        this.limparDadosBeneficiario(true)
        this.desbloquearCamposBeneficiario()
      },
      async next () {
        let id_empresa = this.$session.get('id_empresa')
        const form = this.$refs.form

        this.pedido.cliente.id_usuario = this.$session.get('id_usuario')
        this.pedido.id_empresa = this.pedido.id_empresa >= 1 ? this.pedido.id_empresa : id_empresa
        this.pedido.id_empresa_venda_logada = id_empresa
        this.pedido.id_unidade_negocio = this.$session.get('id_unidade_negocio')

        if ((typeof this.pedido.vl_parcela !== 'undefined' && this.pedido.vl_parcela && this.percentual_minimo_venda > 0) || (typeof this.pedido.politica_vendas !== 'undefined' && this.pedido.politica_vendas && this.percentual_minimo_venda > 0)) {
          let parcela = typeof this.pedido.politica_vendas !== 'undefined' && this.pedido.politica_vendas ? this.pedido.plano.valor_parcela : this.pedido.vl_parcela
          let renda = this.pedido.cliente.pessoa === TipoPessoa.Fisica ? this.pedido.cliente.renda : this.pedido.cliente.faturamento_medio
          let resul = (parcela / renda) * 100
          if (resul > this.percentual_minimo_venda) {
            return notification(AlertTypes.WARN, 'O valor da parcela selecionada compromete mais do que ' + this.percentual_minimo_venda + '% da renda, venda não permitida.')
          }
        }

        if (!this.verificarFaturamentoParaIniciarVenda(this.pedido.cliente)) {
          return
        }

        if (form.validate()) {
          this.sendAnalytics()
          this.pedido.cliente.pessoa = TipoPessoa.Juridica
          this.pedido.cliente.tribanco = this.is_tribanco
          if (typeof this.pedido.cliente.beneficiario.id_parentesco === 'undefined') {
            this.pedido.cliente.beneficiario.id_parentesco = null
          }

          if (this.checkBeneficiarioSocio(this.pedido.cliente)) {
            this.$http.post('/clientes', this.pedido.cliente)
              .then((result) => {
                this.finalizouFluxoTela = true

                this.pedido.cliente = { ...this.pedido.cliente, ...result.data }
                this.$emit('input', this.pedido)
                this.$emit('nextPage')
              })
              .catch(() => {
                this.finalizouFluxoTela = false
                notification(AlertTypes.ERROR, 'Foi encontrado um erro ao salvar os dados do cliente, caso o erro continue, entre em contato com a Área de Suporte.')
              })
          }
        }
      },
      sendAnalytics () {
        sendAnalyticsEvent(this.$gtag, 'cadastro_pessoa', {
          tipo_pessoa: 'PJ',
          data_fundacao: this.pedido.cliente.data_fundacao,
          tipo_empresa: this.pedido.cliente.id_tipo_empresa,
          atividade: this.pedido.cliente.id_atividade,
          faturamento: this.pedido.cliente.faturamento_medio,
          patrimonio: this.pedido.cliente.patrimonio,
          data_nascimento: this.pedido.cliente.data_nascimento_socio,
          sexo_nascimento: this.pedido.cliente.genero,
          nacionalidade: this.pedido.cliente.nacionalidade,
          condicao_politica: this.pedido.cliente.politicamente_exposto,
          parentesco: this.pedido.cliente.id_parentesco,
          cargo: this.pedido.cliente.id_cargo_politico,
          source_menu: this.jornada_venda,
          cadastro_existente: this.pedido.cliente.bloqueado
        })
      },
      prev () {
        this.$emit('prevPage')
      },

      async getCliente () {
        if (!validaCNPJ(this.pedido.cliente.cnpj)) {
          return
        }
        if (this.pedido.cliente.cnpj === this.ultimoDocumentoInserido) {
          return
        }

        this.ultimoDocumentoInserido = this.pedido.cliente.cnpj
        if (this.is_tribanco) { // Se o representante for tribanco o processo de trazer o PJ é diferente.
          await this.proccessClienteTribanco()
        } else {
          await this.proccessClienteNewcon()
        }
      },
      async proccessClienteTribanco () {
        const pessoaJuridicaResponse = await this.$http.get('/clientes/pessoajuridicaweb', { params: { CD_Inscricao_Nacional: this.pedido.cliente.cnpj } })

        if (pessoaJuridicaResponse && pessoaJuridicaResponse.data && (pessoaJuridicaResponse.data.ID_Pessoa || pessoaJuridicaResponse.data.NM_Razao_Social)) {
          if (pessoaJuridicaResponse.data.ID_Pessoa) { // Se vier ID_Pessoa o cliente é do newcon.
            this.proccessClienteNewcon(pessoaJuridicaResponse)
          }

          const pessoaJuridica = pessoaJuridicaResponse.data
          this.pedido.cliente.bloqueado = true
          this.pedido.cliente.socio_bloqueado = true
          this.pedido.cliente.beneficiario.bloqueado = true

          if (pessoaJuridica.contatos.length > 0) {
            pessoaJuridica.contatos.forEach(contato => {
              if (!contato.ID_Tipo_Telefone) { // Se não tiver essa chave é e-mail.
                this.pedido.cliente.email = contato.E_Mail
              }
            })

            const telefones_celular = pessoaJuridica.contatos.filter(telefone => telefone.ID_Tipo_Telefone === TipoTelefone.telefone_celular)
            const telefones_residencial = pessoaJuridica.contatos.filter(telefone => telefone.ID_Tipo_Telefone === TipoTelefone.telefone_residencial)
            const telefones_comercial = pessoaJuridica.contatos.filter(telefone => telefone.ID_Tipo_Telefone === TipoTelefone.telefone_comercial)
            this.setTelefone(telefones_celular, 'telefone_celular')
            this.setTelefone(telefones_residencial, 'telefone_residencial')
            this.setTelefone(telefones_comercial, 'telefone_comercial')
          }

          // Aqui eu junto os models de socio e PJ pq estão vindo juntos agora.
          this.$emit('loadCliente', pessoaJuridica, Object.assign(newConClienteMap, newConSocioMap, newConBeneficiarioMap))
          if (pessoaJuridica.enderecos) {
            this.pedido.cliente.enderecos = pessoaJuridica.enderecos
          }

          this.fillClienteSearch()
          this.fillSocioSearch()
          this.fillBeneficiarioSearch()
        } else {
          await this.proccessClienteNewcon()
        }
      },
      async proccessClienteNewcon (pessoaJuridicaResponse) {
        this.bloqueado_newcon = 0
        if (!pessoaJuridicaResponse) {
          try {
            // eslint-disable-next-line no-unused-vars
            pessoaJuridicaResponse = await this.$http.get('/clientes/pessoajuridica', { params: { CD_Inscricao_Nacional: this.pedido.cliente.cnpj } })
          } catch (error) {
            if (error.response?.status === 409) {
              this.bloqueado_newcon = error.response.data.bloqueado_newcon
              notification(AlertTypes.WARN, error.response?.data?.error)
            } else {
              notification(AlertTypes.ERROR, error.response?.data?.error)
            }
          }
        }

        if (!this.is_tribanco) {
          // eslint-disable-next-line no-unused-vars
          this.pessoaJuridicaIntermediariaResponse = await this.$http.get('/pessoa_base', { params: { CD_Inscricao_Nacional: this.pedido.cliente.cnpj, tipo_pessoa: 'juridica' } })

          this.pedido.id_cliente = this.pessoaJuridicaIntermediariaResponse.data.id_cliente
        }

        if (pessoaJuridicaResponse && pessoaJuridicaResponse.data && pessoaJuridicaResponse.data.ID_Pessoa) {
          const pessoaJuridica = pessoaJuridicaResponse.data
          this.pedido.cliente.bloqueado = true

          const emailResponse = await this.$http.get('/clientes/email', { params: { ID_Pessoa: pessoaJuridica.ID_Pessoa } })
          if (emailResponse && emailResponse.data) {
            this.pedido.cliente.email = emailResponse.data.E_Mail
          }

          if (!this.is_tribanco) {
            const pessoaFinalJuridica = await this.checkCamposClienteJuridica(pessoaJuridica, this.pessoaJuridicaIntermediariaResponse.data)
            this.$emit('loadCliente', pessoaFinalJuridica, { ...newConClienteMap, ...baseIntermediariaMap })
          } else {
            this.$emit('loadCliente', pessoaJuridica, { ...newConClienteMap, ...baseIntermediariaMap })
          }

          const sociosComCpf = this.getDocumentoSociosComCpf(pessoaJuridica)
          const possuiSociosValidos = sociosComCpf.length > 0
          const possuiBeneficiario = sociosComCpf.length > 1
          if (possuiSociosValidos) {
            this.getSocio(sociosComCpf[0])
          }
          if (possuiBeneficiario) {
            this.getBeneficiario(sociosComCpf[1])
          }

          const telefonesResponse = await this.$http.get('/clientes/telefone', { params: { ID_Pessoa: pessoaJuridica.ID_Pessoa } })
          let telefones = get(telefonesResponse, 'data.TelefonePessoa.stcTelefonePessoa', [])
          const telefones_celular = telefones.filter(telefone => telefone.ID_Tipo_Telefone === TipoTelefone.telefone_celular)
          const telefones_residencial = telefones.filter(telefone => telefone.ID_Tipo_Telefone === TipoTelefone.telefone_residencial)
          const telefones_comercial = telefones.filter(telefone => telefone.ID_Tipo_Telefone === TipoTelefone.telefone_comercial)
          this.setTelefone(telefones_celular, 'telefone_celular')
          this.setTelefone(telefones_residencial, 'telefone_residencial')
          this.setTelefone(telefones_comercial, 'telefone_comercial')
        } else {
          if (!this.is_tribanco) {
            const pessoaFinalJuridica = await this.checkCamposClienteJuridica(false, this.pessoaJuridicaIntermediariaResponse.data)
            this.$emit('loadCliente', pessoaFinalJuridica, { ...newConClienteMap, ...baseIntermediariaMap })
          }
        }
      },
      getDocumentoSociosComCpf (pessoaJuridica) {
        let sociosValidos = []

        if (pessoaJuridica) {
          if (pessoaJuridica.CD_Inscricao_Nacional_Socio && validaCPF(pessoaJuridica.CD_Inscricao_Nacional_Socio)) {
            sociosValidos.push(pessoaJuridica.CD_Inscricao_Nacional_Socio)
          }
          if (pessoaJuridica.CD_Inscricao_Nacional_Socio_2 && validaCPF(pessoaJuridica.CD_Inscricao_Nacional_Socio_2)) {
            sociosValidos.push(pessoaJuridica.CD_Inscricao_Nacional_Socio_2)
          }
          if (pessoaJuridica.CD_Inscricao_Nacional_Socio_3 && validaCPF(pessoaJuridica.CD_Inscricao_Nacional_Socio_3)) {
            sociosValidos.push(pessoaJuridica.CD_Inscricao_Nacional_Socio_3)
          }
        }
        return sociosValidos
      },
      async setTelefone (telefones, tipoTelefone) {
        if (!isEmpty(telefones)) {
          const telefone = telefones.reduce((lastValue, currentValue) => lastValue.ID_Telefone > currentValue.ID_Telefone ? lastValue : currentValue)
          const cidade = await this.$http.get(`/clientes/telefone/ddd/${telefone.ID_Cidade}`)
          this.pedido.cliente[tipoTelefone] = this.maskTelefone(cidade.data.ddd, telefone.Telefone)
        }
      },
      getSocio (cpf) {
        if (typeof (cpf) !== 'string') {
          cpf = this.pedido.cliente.cpf_socio
        }
        if (!validaCPF(cpf)) {
          return
        }
        this.bloqueado_newcon = 0
        this.$http.get('/clientes/pessoafisica', { params: { CD_Inscricao_Nacional: cpf, socio: true } })
          .then(({ data }) => {
            if (data['ID_Pessoa']) {
              this.pedido.cliente.socio_bloqueado = true

              if (data.CD_Inscricao_Nacional) {
                data.CD_Inscricao_Nacional = masker(`${data.CD_Inscricao_Nacional}`, '###.###.###-##', true, tokens)
              }

              this.buscarSocioBancoIntermediario(cpf).then((socio_banco_intermediario) => {
                if (socio_banco_intermediario) {
                  data = socio_banco_intermediario
                }
                this.$emit('loadCliente', data, newConSocioMap)

                this.socio_search.nome_completo = data['NM_Pessoa'] !== ''
                this.socio_search.data_nascimento_socio = data['DT_Nascimento'] !== ''
                this.socio_search.genero = data['ST_Sexo'] !== ''
                this.socio_search.nacionalidade = !isEmpty(data['NM_Nacionalidade'].trim()) && (data['NM_Nacionalidade'] === Nacionalidades.Brasileira || data['NM_Nacionalidade'] === Nacionalidades.Estrangeira)
              })
            } else {
              this.limparDadosSocio()
            }
          }).catch((error) => {
            if (error.response?.status === 409) {
              this.bloqueado_newcon = error.response.data.bloqueado_newcon
              notification(AlertTypes.WARN, error.response?.data?.error)
            } else {
              notification(AlertTypes.ERROR, error.response?.data?.error || 'Erro ao buscar dados do sócio')
            }

            this.limparDadosSocio()
          })
      },

      getBeneficiario (cpf) {
        if (typeof (cpf) !== 'string') {
          cpf = this.pedido.cliente.beneficiario.cpf
        }
        this.checkBeneficiarioSocio(this.pedido.cliente)
        if (!validaCPF(cpf)) {
          return
        }
        this.bloqueado_newcon = 0
        this.$http.get('/clientes/pessoafisica', { params: { CD_Inscricao_Nacional: cpf, beneficiario: true } })
          .then(({ data }) => {
            if (data['ID_Pessoa']) {
              this.pedido.cliente.beneficiario.bloqueado = true

              if (data.CD_Inscricao_Nacional_Beneficiario) {
                data.CD_Inscricao_Nacional_Beneficiario = masker(`${data.CD_Inscricao_Nacional_Beneficiario}`, '###.###.###-##', true, tokens)
              }
              this.buscarBeneficiarioBancoIntermediario(cpf).then((beneficiario_banco_intermediario) => {
                if (beneficiario_banco_intermediario) {
                  data = beneficiario_banco_intermediario
                }
                data.bloqueado = true
                this.$emit('loadCliente', data, newConBeneficiarioMap)
                this.beneficiario_search.nome_completo = data['NM_Pessoa'] !== ''
                this.beneficiario_search.data_nascimento = data['DT_Nascimento'] !== ''
                this.beneficiario_search.genero = data['ST_Sexo'] !== ''
                this.beneficiario_search.nacionalidade = !isEmpty(data['NM_Nacionalidade'].trim()) && (data['NM_Nacionalidade'] === Nacionalidades.Brasileira || data['NM_Nacionalidade'] === Nacionalidades.Estrangeira)
              })
            } else {
              this.limparDadosBeneficiario(false)
            }
          }).catch((error) => {
            if (error.response?.status === 409) {
              this.bloqueado_newcon = error.response.data.bloqueado_newcon
              notification(AlertTypes.WARN, error.response?.data?.error)
            } else {
              notification(AlertTypes.ERROR, error.response?.data?.error)
            }
          })
      },
      buscarBeneficiarioBancoIntermediario (cpf) {
        cpf = masker(`${cpf}`, '###.###.###-##', true, tokens)
        return this.$http.get('/clientes/pessoafisica/beneficiario', { params: { cpf: cpf, cnpj: this.pedido.cliente.cnpj } })
          .then(({ data }) => {
            return data
          })
          .catch((err) => {
            const status_code = get(err, 'response.status', 500)
            if (status_code === 404) {
              return false
            }
            notification(AlertTypes.ERROR, err, 'Não foi possivel buscar o beneficiário')
          })
      },
      buscarSocioBancoIntermediario (cpf) {
        return this.$http.get('/clientes/pessoafisica/socio', { params: { cpf: cpf, cnpj: this.pedido.cliente.cnpj } })
          .then(({ data }) => {
            return data
          })
          .catch((err) => {
            const status_code = get(err, 'response.status', 500)
            if (status_code === 404) {
              return false
            }
            notification(AlertTypes.ERROR, err, 'Não foi possivel buscar o sócio')
          })
      },
      fillSocioSearch () {
        Object.keys(this.socio_search).forEach(key => {
          const val = this.pedido.cliente[key]

          this.socio_search[key] = !isNil(val) && (!isString(val) || !isEmpty(val))
        })
      },
      fillBeneficiarioSearch () {
        Object.keys(this.pedido.cliente.beneficiario_search).forEach(key => {
          const val = this.pedido.cliente[key]

          this.beneficiario_search[key] = !isNil(val) && (!isString(val) || !isEmpty(val))
        })
      },
      fillClienteSearch () {
        Object.keys(this.model_search).forEach(key => {
          const val = this.pedido.cliente[key]

          this.model_search[key] = !isNil(val) && (!isString(val) || !isEmpty(val))
        })
      },
      maskTelefone (ddd, telefone) {
        return masker(`${ddd}${telefone}`, [ '(##) ####-####', '(##) #####-####' ], true, tokens)
      },
      getAtividades () {
        return this.$http.get('/atividades').then(result => {
          this.atividades = result.data
        })
      },
      getTiposEmpresa () {
        return this.$http.get('/tipos_empresa')
          .then(res => {
            this.tipos_empresa = res.data
          })
      },
      loadConfiguracaoIdade () {
        return -this.$http.get('/configuracaoidade/get')
          .then(result => {
            if (result.data) {
              this.configuracao_idade = result.data.valor_idade
            }
          })
          .catch(err => console.error(err))
      },
      limparDados () {
        // O omit é para não limpar o CPF
        Object.assign(this.pedido.cliente, omit(clienteDefault(), 'cnpj'))
      },
      desbloquearCampos () {
        Object.keys(this.model_search).forEach(key => {
          this.model_search[key] = false
        })
      },
      limparDadosSocio () {
        this.desbloquearCamposSocio()
        this.pedido.cliente.data_nascimento_socio = ''
        this.pedido.cliente.nome_mae = ''
        this.pedido.cliente.nacionalidade = ''
        this.pedido.cliente.genero = ''
        this.pedido.cliente.id_estado_civil = ''
        this.$refs.nome_completo.reset()
        this.$nextTick(() => {
          if (this.$refs.data_nascimento_socio) {
            this.$refs.data_nascimento_socio.reset()
          }
        })
        this.$refs.genero.reset()
        this.$refs.nacionalidade.reset()
        this.$refs.percentual_participacao.reset()
        this.$refs.politicamente_exposto.reset()
      },
      limparDadosBeneficiario (limparCpf = true) {
        if (!this.pedido.cliente.exibir_campos_beneficiario) return
        this.desbloquearCamposBeneficiario()
        if (limparCpf) {
          this.pedido.cliente.beneficiario.cpf = ''
        }
        this.pedido.cliente.beneficiario.data_nascimento = ''
        this.pedido.cliente.beneficiario.nacionalidade = ''
        this.pedido.cliente.beneficiario.genero = ''
        this.pedido.cliente.beneficiario.politicamente_exposto = null
        this.$refs.nome_completo_beneficiario.reset()
        this.$nextTick(() => {
          if (this.$refs.data_nascimento_beneficiario) {
            this.$refs.data_nascimento_beneficiario.reset()
          }
        })
        this.$refs.genero_beneficiario.reset()
        this.$refs.nacionalidade_beneficiario.reset()
      },
      resetForm () {
        this.$refs.form.resetValidation()
      },
      desbloquearCamposSocio () {
        this.socio_search.nome_completo = false
        this.socio_search.data_nascimento_socio = false
        this.socio_search.genero = false
        this.socio_search.nacionalidade = false
        this.socio_search.percentual_participacao = false
        this.socio_search.politicamente_exposto = false
      },
      desbloquearCamposBeneficiario () {
        this.beneficiario_search.nome_completo = false
        this.beneficiario_search.data_nascimento = false
        this.beneficiario_search.genero = false
        this.beneficiario_search.nacionalidade = false
        this.beneficiario_search.percentual_participacao = false
        this.beneficiario_search.politicamente_exposto = false
      },
      checkPorcentagemFinal () {
        let calculo = parseFloat(this.pedido.cliente.beneficiario.percentual_participacao) + parseFloat(this.pedido.cliente.percentual_participacao)

        if (calculo > 100) {
          notification(AlertTypes.WARN, 'A soma dos percentuais de participação não pode ser superior a 100%.')
          this.pedido.cliente.beneficiario.percentual_participacao = 0
        }
      },
      checkBeneficiarioSocio (cliente) {
        if (cliente.beneficiario.cpf !== '' && cliente.cpf_socio !== '' && cliente.beneficiario.cpf === cliente.cpf_socio) {
          notification(AlertTypes.WARN, 'O CPF do Beneficiário Final não pode ser igual ao CPF do Sócio indicado.')
          this.pedido.cliente.beneficiario.cpf = 0
          return false
        } else {
          return true
        }
      },
      dataMinima (v) {
        return (!v || !(v && moment(v, 'DD/MM/YYYY').isAfter(moment(minimumAge(parseInt(this.configuracao_idade))))) || 'A data não pode ser maior')
      },
      checkCamposClienteJuridica (pessoaNewcon, pessoaBase) {
        let pessoa_final = pessoaNewcon === false ? [] : pessoaNewcon

        if (pessoaBase.id_cliente > 0) {
          this.pedido.cliente.id_cliente = pessoaBase.id_cliente
          if (!pessoaNewcon) {
            this.pedido.cliente.id_pessoa_erp = null
          }
        }
        if (!pessoaNewcon && pessoaBase.id_usuario !== this.id_usuario_interno) {
          return []
        }

        if ((!pessoaNewcon || pessoa_final['NM_Razao_Social'] === '') && pessoaBase.razao_social !== '') {
          pessoa_final['NM_Razao_Social'] = pessoaBase.razao_social
        }

        if ((!pessoaNewcon || pessoa_final['NM_Fantasia'] === '') && pessoaBase.nome_fantasia !== '') {
          pessoa_final['NM_Fantasia'] = pessoaBase.nome_fantasia
          this.model_search['data_nascimento'] = false
        }

        if ((!pessoaNewcon || pessoa_final['DT_Fundacao'] === '') && pessoaBase.data_fundacao !== '') {
          pessoa_final['DT_Fundacao'] = pessoaBase.data_fundacao
          this.model_search['genero'] = false
        }

        if ((!pessoaNewcon || pessoa_final['VL_Faturamento_Medio'] === '') && pessoaBase.faturamento_medio !== '') {
          pessoa_final['VL_Faturamento_Medio'] = pessoaBase.faturamento_medio
        }

        if ((!pessoaNewcon || !pessoa_final['ID_Atividade'] > 0) && pessoaBase.id_atividade > 0) {
          this.pedido.cliente.id_atividade = pessoaBase.id_atividade
        }

        if ((!pessoaNewcon || pessoa_final['VL_Patrimonio_Total'] === '') && pessoaBase.patrimonio !== '') {
          pessoa_final['VL_Patrimonio_Total'] = pessoaBase.patrimonio
        }

        if ((!pessoaNewcon || pessoa_final['PE_Participacao_Socio'] === '') && pessoaBase.percentual_participacao !== '') {
          pessoa_final['PE_Participacao_Socio'] = pessoaBase.percentual_participacao
        }

        if (pessoaBase.id_tipo_empresa !== '') {
          this.pedido.cliente.id_tipo_empresa = pessoaBase.id_tipo_empresa
        }

        if (pessoaBase.registro_dados_constitutivos !== '') {
          pessoa_final['registro_dados_constitutivos'] = pessoaBase.registro_dados_constitutivos
        }

        if (this.pedido.cliente.email === '' && pessoaBase.email !== '') {
          this.pedido.cliente.email = pessoaBase.email
        }

        if (!pessoaNewcon) {
          this.pedido.cliente.telefone_celular = pessoaBase.telefone_celular
          this.pedido.cliente.telefone_residencial = pessoaBase.telefone_residencial
          this.pedido.cliente.telefone_comercial = pessoaBase.telefone_comercial

          let socio = []
          socio['CD_Inscricao_Nacional'] = pessoaBase.cpf
          socio['NM_Pessoa'] = pessoaBase.nome_completo
          socio['DT_Nascimento'] = pessoaBase.data_nascimento
          socio['ST_Sexo'] = pessoaBase.genero
          socio['NM_Nacionalidade'] = pessoaBase.nacionalidade !== null ? pessoaBase.nacionalidade : ''
          this.$emit('loadCliente', socio, newConSocioMap)
        }

        if ((!pessoaNewcon || pessoa_final['NO_Documento'] === '') && pessoaBase.inscricao_estadual !== '') {
          pessoa_final['NO_Documento'] = pessoaBase.inscricao_estadual
        }

        return pessoa_final
      },
      async getLimiteComprometimentoRendaWithRetry () {
        let retryCount = 0
        const maxRetries = 3
        if ((typeof this.pedido.vl_parcela !== 'undefined' && this.pedido.vl_parcela) || (typeof this.pedido.politica_vendas !== 'undefined' && this.pedido.politica_vendas)) {
          while (retryCount < maxRetries) {
            try {
              const result = await this.$http.get(`/parametrizacao/load_parametrizacao/limite_comprometimento_renda`)
              if (result.data) {
                this.percentual_minimo_venda = result.data.valor
                break
              }
            } catch (err) {
            }
            retryCount++
          }
        }
      }
    }
  }
</script>

<style scoped>
  label {
    font-size: 1.0rem;
    color: var(--darkgray)
  }

  .fade-expand-enter-active, .fade-expand-leave-active {
    transition: all 0.3s ease; opacity: 1; overflow: hidden;
  }

  .fade-expand-enter, .fade-expand-leave-to {
     opacity: 0; margin-top: 0 !important;
  }
</style>
